import React from 'react'
import ListBrandsPage from "./ListBrandsPage";

function ListBrandsContainer(props) {
    return (
        <div className="SettingShippingRuleContainer">
            <ListBrandsPage/>
        </div>
    )
}

export default ListBrandsContainer